export const google_drive = () => (
  <>
    <path
      d="M2.69231 19.141L3.67949 20.8461C3.88462 21.2051 4.17949 21.4872 4.52564 21.6923L8.05128 15.5897H1C1 15.9872 1.10256 16.3846 1.30769 16.7436L2.69231 19.141Z"
      fill="#0066DA"
    />
    <path
      d="M12.1923 8.41025L8.66667 2.30769C8.32051 2.51282 8.02564 2.79487 7.82051 3.15384L1.30769 14.4359C1.10634 14.7871 1.00027 15.1849 1 15.5897H8.05128L12.1923 8.41025Z"
      fill="#00AC47"
    />
    <path
      d="M19.859 21.6923C20.2051 21.4872 20.5 21.2051 20.7051 20.8461L21.1154 20.141L23.0769 16.7436C23.2821 16.3846 23.3846 15.9872 23.3846 15.5897H16.3328L17.8333 18.5385L19.859 21.6923Z"
      fill="#EA4335"
    />
    <path
      d="M12.1923 8.41026L15.7179 2.30769C15.3718 2.10256 14.9744 2 14.5641 2H9.82051C9.41026 2 9.01282 2.11538 8.66667 2.30769L12.1923 8.41026Z"
      fill="#00832D"
    />
    <path
      d="M16.3333 15.5897H8.05128L4.52564 21.6923C4.8718 21.8974 5.26923 22 5.67949 22H18.7051C19.1154 22 19.5128 21.8846 19.859 21.6923L16.3333 15.5897Z"
      fill="#2684FC"
    />
    <path
      d="M19.8205 8.79487L16.5641 3.15384C16.359 2.79487 16.0641 2.51282 15.7179 2.30769L12.1923 8.41025L16.3333 15.5897H23.3718C23.3718 15.1923 23.2692 14.7949 23.0641 14.4359L19.8205 8.79487Z"
      fill="#FFBA00"
    />
  </>
);
